module.exports = __webpack_public_path__ + "img/bg_icon_2.cdca2c87.svg";